import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';

export const Route = createFileRoute(
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/customer-cash-balance/_customer-cash-balance',
)({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'customer-cash-balances',
        label: 'Core',
        to: '/clearing/operations/customer-cash-balance',
      }),
    }) satisfies AggregateBreadcrumb,
});
